module.exports = __webpack_public_path__ + "7461c007488b8d9a17bd5d4517887f97.png";